import { Theme } from '@mui/material/styles';
import { SxProps } from '@mui/system';
import { FC } from 'react';
import { DropzoneInputProps, DropzoneRootProps } from 'react-dropzone';
import Box from 'yoda-ui/components/Box';
import Icon from 'yoda-ui/components/Icons/Icon';
import { Icons } from 'yoda-ui/components/Icons/Icon/Icon';
import { YodaBorderRadius, YodaColors, YodaFontSize, YodaFontWeight, YodaSpacing } from 'yoda-ui/yodaTheme';

type DropZoneProps = {
  label: string;
  btnLabel: string;
  btnIcon: Icons;
  message: string;
  getRootProps: <T extends DropzoneRootProps>(props?: T | undefined) => T;
  getInputProps: <T extends DropzoneInputProps>(props?: T | undefined) => T;
  isDragActive: boolean;
};

const DropZone: FC<DropZoneProps> = ({
  label,
  btnLabel,
  btnIcon,
  message,
  getRootProps,
  getInputProps,
  isDragActive,
}) => {
  const boxStyle: SxProps<Theme> = {
    border: `2px dashed ${isDragActive ? YodaColors.blue7 : YodaColors.gray6}`,
    borderRadius: `${YodaBorderRadius.small}`,
  };

  const dropTitleStyle: SxProps<Theme> = {
    display: 'flex',
    alignItems: 'center',
    gap: '4px',
    color: YodaColors.blue7,
    fontWeight: '500',
    fontSize: YodaFontSize.small,
  };

  const labelBox = <>
    <Box fontWeight='600' paddingBottom={ YodaSpacing.medium }>
      { label }
    </Box>
  </>;

  return (
    <>
      { label && labelBox }
      <Box
        display="flex"
        width="100%"
        paddingY={ YodaSpacing.medium }
        { ...getRootProps() }
        flexDirection="column"
        sx={ boxStyle }
      >
        <Box
          display="flex"
          flexDirection="column"
          alignItems="center"
          alignSelf="Center"
          justifySelf="center"
          fontWeight={ YodaFontWeight.light }
        >
          <Box sx={ dropTitleStyle }>
            <Icon name={ btnIcon } style={ { width: '16px' } } />
            { btnLabel }
          </Box>
          <input { ...getInputProps() } data-testid="dropzone" />
          <Box
            color={ YodaColors.textSecondary }
            fontSize={ YodaFontSize.small }
            textAlign="center"
          >
            { message }
          </Box>
        </Box>
      </Box>
    </>
  );
};

export default DropZone;
